"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCartFailTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const control_1 = require("@common/form/control");
const auth_1 = require("@auth/services/auth");
const translation_1 = require("@translation/services/translation");
const domain_1 = require("@domain/services/domain");
const simple_1 = require("@domain/templates/simple");
const loader_1 = require("@common/loader/templates/loader");
/**
 * Всплывающее окно ошибки добавления домена с предложениями
 */
let CartFailPopup = class CartFailPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = true;
        /**
         * Форма
         */
        this.form = new control_1.Form({
            mail: new control_1.TextControl(''),
        });
        /**
         * Домены
         */
        this.domains = [];
        this.authService = typedi_1.Container.get(auth_1.AuthService);
        this.domainService = typedi_1.Container.get(domain_1.DomainService);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchDomains();
    }
    /**
     * Получает домены
     */
    fetchDomains() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            const { domain } = this.params;
            if (this.domainService.isThirdLevelDomain(domain)) {
                this.loading = false;
                return;
            }
            try {
                const { data: { items } } = yield this.domainService.getSimilar(domain);
                this.domains = items;
            }
            catch (err) {
            }
            finally {
                this.loading = false;
            }
        });
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered modal-fullscreen-sm-down modal-cart-fail">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        
                        ${this.loading
            ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    ${(0, loader_1.getLoaderTemplate)(true, this.translationService)}
                                </div>
                            </div>     
                        ` : (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    <h2 class="mb-5">${this.translationService.instant('we_are_sorry')}</h2>
                                    <p class="mb-3">${this.domains.length === 0
            ? this.translationService.instant('somebody_already_bought_this_domain_with_empty_similar')
            : this.translationService.instant('somebody_already_bought_this_domain')}
                                    </p>
                                    <div class="d-flex flex-column">
                                        ${this.domains.map((domain) => (0, simple_1.getSimpleDomainTemplate)(domain, this.translationService))}
                                    </div>
                                </div>
                            </div>
                        `}
                    </div>
                </div>
            </div>
        `;
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], CartFailPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], CartFailPopup.prototype, "params", void 0);
CartFailPopup = __decorate([
    (0, decorators_js_1.customElement)('art-cart-fail-popup'),
    __metadata("design:paramtypes", [])
], CartFailPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getCartFailTemplate(params) {
    return (0, lit_html_1.html) `<art-cart-fail-popup .params="${params}"></art-cart-fail-popup>`;
}
exports.getCartFailTemplate = getCartFailTemplate;
window.PopupController.registerTemplate('cart-fail', getCartFailTemplate);
